import {
  awaitAnimate,
  Particle,
  ParticleModes,
} from "../../../engine/anims/Particle";

export const HitParticle = {
  mode: ParticleModes.DRAW_OVER_LAST,
  char: null,
  fg: null,
  bg: "rgba(255, 100, 200, 0.75)",
  animate: async (particle: Particle<void>) => {
    await awaitAnimate({
      driver: particle.driver,
      from: "rgba(255, 100, 200, 0.75)",
      to: "rgba(255, 100, 200, 0.25)",
      duration: 100,
      onUpdate: (latest) => {
        particle.bg = latest;
      },
    });

    await awaitAnimate({
      driver: particle.driver,
      from: "rgba(255, 100, 200, 0.25)",
      to: "rgba(255, 100, 200, 0.75)",
      duration: 100,
      onUpdate: (latest) => {
        particle.bg = latest;
      },
    });
    await awaitAnimate({
      driver: particle.driver,
      from: "rgba(255, 100, 200, 0.75)",
      to: "rgba(255, 100, 200, 0.25)",
      duration: 100,
      onUpdate: (latest) => {
        particle.bg = latest;
      },
    });
  },
};
